import axios from 'axios';

import {
  FETCH_DATA,
  FETCH_DATA_SUCCESS,
  FETCH_DATA_ERROR,
} from './constants';

export function fetchDataStart() {
  return {
    type: FETCH_DATA,
  };
}

export function fetchDataSuccess(data) {
  return {
    data,
    type: FETCH_DATA_SUCCESS,
  };
}

export function fetchDataError(error) {
  return {
    error,
    type: FETCH_DATA_ERROR,
  };
}

export function fetchData() {
  return async (dispatch) => {
    dispatch(fetchDataStart());
    try {
      const { data } = await axios.get('/api/profile/convergence/tv/');
      dispatch(fetchDataSuccess(data));
    } catch (error) {
      dispatch(fetchDataError(error));
    }
  };
}
